import Alpine from 'alpinejs';
import headerSpace from './alpine/header-space';
import marquee from './alpine/marquee';
import carousel from './alpine/carousel';
import carouselItem from './alpine/carousel-item';
import featuresInterface from './alpine/features-interface';
import mobileMenu from './alpine/mobile-menu';
import postCards from './alpine/post-cards';
import filterControl from './alpine/filter-control';
import searchControl from './alpine/search-control';
import masonry from 'alpinejs-masonry';
import intersect from '@alpinejs/intersect';
import accordion from './alpine/accordion';
import siteSearch from './alpine/site-search';
import tabs from './alpine/tabs';

import collapse from '@alpinejs/collapse';
// import mobileMenu from './alpinejs/mobile-menu';
// import carousel from './alpinejs/carousel';

Alpine.plugin(collapse);
Alpine.plugin(masonry);
Alpine.plugin(intersect);

// Alpine.data('mobileMenu', mobileMenu);
// Alpine.data('carousel', carousel);
Alpine.data('headerSpace', headerSpace);
Alpine.data('marquee', marquee);
Alpine.data('carousel', carousel);
Alpine.data('carouselItem', carouselItem);
Alpine.data('featuresInterface', featuresInterface);
Alpine.data('mobileMenu', mobileMenu);
Alpine.data('postCards', postCards);
Alpine.data('filterControl', filterControl);
Alpine.data('searchControl', searchControl);
Alpine.data('accordion', accordion);
Alpine.data('siteSearch', siteSearch);
Alpine.data('tabs', tabs);


window.Alpine = Alpine;
ready( () => Alpine.start() );


function ready(fn) {
	if (document.readyState != 'loading') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}

